import { Edit, Add } from '@drift-labs/icons';
import {
	AccountsTableItem,
	UseAccountsTable,
} from 'src/components/PortfolioPage/PortfolioAccountsSubPage/AccountsTable/hooks/useAccountsTable';
import IconButton from 'src/components/primitives/IconButton/IconButton';
import { cm } from 'src/utils/classNames';
import { abbreviateAddress } from 'src/utils/strings';

interface Props
	extends
		Pick<
			AccountsTableItem,
			| 'isDelegated'
			| 'isDelegatedToEmbeddedWallet'
			| 'isDelegatedToNonEmbeddedWallet'
			| 'delegate'
			| 'userId'
			| 'authority'
		>,
		Pick<UseAccountsTable, 'openUpdateDelegateModal'> {}

export default function AccountsTableDelegateCell({
	isDelegated,
	isDelegatedToEmbeddedWallet,
	isDelegatedToNonEmbeddedWallet,
	delegate,
	openUpdateDelegateModal,
	userId,
	authority,
}: Props) {
	const content = (() => {
		if (!isDelegatedToNonEmbeddedWallet) {
			return '-';
		}

		return (
			<>
				{abbreviateAddress(delegate)}{' '}
				<IconButton
					size="sm"
					variant="tertiary"
					className="-m-sm p-sm"
					onClick={() => openUpdateDelegateModal(userId, authority, delegate)}
					icon={isDelegated ? Edit : Add}
				/>
			</>
		);
	})();

	return (
		<div
			className={cm(
				'flex items-center gap-x-xs',
				!isDelegated && 'text-text-secondary',
				isDelegatedToEmbeddedWallet && 'text-text-tertiary'
			)}
		>
			{content}
		</div>
	);
}
